export const REFUND_STATUS_TYPES_DIC = {
  SENT: 'sent',
  RECEIVED: 'received',
  CANCELLED: 'cancelled',
  DOCUMENT_PENDING: 'document_pending',
  IN_PROCESS: 'in_process',
  PROCESSED: 'processed'
}

export const REFUND_STATUS_OPTIONS = {
  [REFUND_STATUS_TYPES_DIC.SENT]: {
    label: 'ENVIADO',
    className: 'order-status sent-style'
  },
  [REFUND_STATUS_TYPES_DIC.RECEIVED]: {
    label: 'RECIBIDO',
    className: 'order-status received-style'
  },
  [REFUND_STATUS_TYPES_DIC.CANCELLED]: {
    label: 'ANULADO',
    className: 'order-status cancelled-style'
  },
  [REFUND_STATUS_TYPES_DIC.DOCUMENT_PENDING]: {
    label: 'PENDIENTE',
    className: 'order-status refund-pending-style'
  },
  [REFUND_STATUS_TYPES_DIC.IN_PROCESS]: {
    label: 'EN PROCESO',
    className: 'order-status in-progress-style'
  },
  [REFUND_STATUS_TYPES_DIC.PROCESSED]: {
    label: 'PROCESADO',
    className: 'order-status processed-style'
  }
}

export const REFUND_STATUS_FILTER_ORDER = [
  REFUND_STATUS_TYPES_DIC.DOCUMENT_PENDING,
  REFUND_STATUS_TYPES_DIC.IN_PROCESS,
  REFUND_STATUS_TYPES_DIC.SENT,
  REFUND_STATUS_TYPES_DIC.PROCESSED,
  REFUND_STATUS_TYPES_DIC.RECEIVED,
  REFUND_STATUS_TYPES_DIC.CANCELLED
]

export const PROCESADOR_STATUS_FILTER_VALUES = [
  REFUND_STATUS_TYPES_DIC.PROCESSED,
  REFUND_STATUS_TYPES_DIC.RECEIVED,
  REFUND_STATUS_TYPES_DIC.CANCELLED
]

export const PROCESADOR_STATUS_FILTER_LABELS = PROCESADOR_STATUS_FILTER_VALUES.map(
  (value) => REFUND_STATUS_OPTIONS[value].label
)

// Listado solo con ejecuta.refunds:READ (sin permisos gated de aprobación/ERP).
export const BASE_STATUS_FILTER_VALUES = [
  REFUND_STATUS_TYPES_DIC.SENT,
  REFUND_STATUS_TYPES_DIC.PROCESSED,
  REFUND_STATUS_TYPES_DIC.RECEIVED,
  REFUND_STATUS_TYPES_DIC.CANCELLED
]

export const BASE_STATUS_FILTER_LABELS = BASE_STATUS_FILTER_VALUES.map(
  (value) => REFUND_STATUS_OPTIONS[value].label
)

export const REFUND_FILTER_KEYS = {
  CLIENT: 'CLIENTE',
  USER: 'CREADO POR',
  WAREHOUSE: 'BODEGA',
  STATUS: 'ESTADO'
}

export const REFUND_STATUS_FILTER_OPTIONS = REFUND_STATUS_FILTER_ORDER.map(
  (value) => REFUND_STATUS_OPTIONS[value].label
)

export const REFUND_LABEL_TO_STATUS_VALUE = Object.fromEntries(
  Object.entries(REFUND_STATUS_OPTIONS).map(([value, { label }]) => [label, value])
)
